<template>
    <div v-if="showInfoModal">
        <b-modal v-model="showInfoModal" content-class="custom-modal">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="close"></span>
            </template>

            <div v-if="true">
                {{ getStickerInfo() }}
                <div class="row_group btns">
                    <div class="conf-btn" @click="onOnePerPageClick()">One per page</div>
                    <div class="conf-btn" @click="onRoedaClick()">Roeda</div>
                    <div class="conf-btn" @click="onSingleTestClick()">SingleTest</div>
                </div>
                <div class="row_group">
                    <b-form-group class="mt-3">
                        <span :class="{red: this.questionIdsRed}">Question id from:</span>
                        <b-form-input
                            id="input-formatter"
                            v-model="settings.pdfConfigDialogModel.q_id_from"
                            placeholder="Question id (inclusively)"
                            type="number"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group class="mt-3">
                        <span :class="{red: this.questionIdsRed}">Question id to:</span>
                        <b-form-input
                            id="tooltip-button-variant"
                            v-model="settings.pdfConfigDialogModel.q_id_to"
                            placeholder="Question id (inclusively)"
                            type="number"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="row_group">
                    <b-form-group class="mt-3">
                        Page width ({{ settings.pdfConfigDialogModel.measure }}, enter 0 for auto):
                        <div style="display: flex;">
                            <b-form-input
                                id="input-formatter"
                                v-model="settings.pdfConfigDialogModel.page_width"
                                placeholder="Enter page width"
                                type="number"
                            ></b-form-input>
                        </div>
                        <span class="hint">Max 110'' for Roeda</span>
                    </b-form-group>
                    <b-form-group class="mt-3">
                        Page height ({{ settings.pdfConfigDialogModel.measure }}, enter 0 for auto):
                        <b-form-input
                            id="tooltip-button-variant"
                            v-model="settings.pdfConfigDialogModel.page_height"
                            placeholder="Enter page height"
                            type="number"
                        ></b-form-input>
                        <span class="hint">Max 52'' for Roeda</span>
                    </b-form-group>
                </div>
                <div class="row_group">
                    <b-form-group class="mt-3">
                        Count of columns on the page:
                        <b-form-input
                            id="input-formatter"
                            v-model="settings.pdfConfigDialogModel.col_count"
                            placeholder="Enter columns count"
                            type="number"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group class="mt-3">
                        Count of rows on the page:
                        <b-form-input
                            id="input-formatter"
                            v-model="settings.pdfConfigDialogModel.row_count"
                            placeholder="Enter rows count"
                            type="number"
                        ></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <template v-slot:modal-footer>
                <b-button variant="primary" @click="validate()">
                    Generate
                </b-button>

            </template>
        </b-modal>

    </div>
</template>

<script>
import _ from "lodash";
import errorMixin from '@/mixins/errorMixin';

export default {
    name: "pdfGenerationConfigDialog",
    mixins: [errorMixin],
    data() {
        return {
            showInfoModal: !_.isEmpty(this.settings),
            questionIdsRed: false,
        }
    },
    watch: {
        settings(newValue) {
            this.showInfoModal = !_.isEmpty(newValue)
            if (this.showInfoModal) {
                this.initData()
            }
        },
        'settings.pdfConfigDialogModel.q_id_from'(newValue) {
            this.recalcColumns()
        },
        'settings.pdfConfigDialogModel.q_id_to'(newValue) {
            this.recalcColumns()
        },
    },
    props: {
        settings: {
            type: [Object, null],
            default: () => {
                return {}
            }
        },
    },
    methods: {
        initData() {
            let config = this.settings.pdfConfigDialogModel
            config.row_count = Math.floor(config.page_height / config.sticker_height)
        },
        getStickerInfo() {
            let config = this.settings.pdfConfigDialogModel
            let val = `Sticker width: ${config.sticker_width}${config.measure},
            Sticker height: ${config.sticker_height}${config.measure}`
            return val
        },
        recalcColumns() {
            let config = this.settings.pdfConfigDialogModel
            if (config.page_width == 0) return;

            let questionsCount = this.getQuestionsCount()
            this.questionIdsRed = questionsCount <= 0
            if (questionsCount <= 0) return
            console.log(`questionsCount: ${questionsCount}`)

            let cols = Math.ceil(questionsCount / config.row_count)
            console.log(`cols: ${cols}`)
            let maxCols = Math.floor(config.page_width / config.sticker_width)
            console.log(`maxCols: ${maxCols}`)
            if (cols > maxCols) {
                config.col_count = maxCols
            } else {
                config.col_count = cols
            }
        },
        validate() {
            let config = this.settings.pdfConfigDialogModel

            let questionsCount = this.getQuestionsCount()
            this.questionIdsRed = questionsCount <= 0
            if (questionsCount <= 0) {
                this.showErrorModal('Questions range should be set')
                return
            }
            let pageWidth = config.page_width
            if (pageWidth == 0) pageWidth = config.col_count * config.sticker_width
            let pageHeight = config.page_height
            if (pageHeight == 0) pageHeight = config.row_count * config.sticker_height
            if (config.row_count * config.sticker_height > pageHeight) {
                this.showErrorModal('Rows count is too big to fit page height')
                return
            }
            if (config.col_count * config.sticker_width > pageWidth) {
                this.showErrorModal('Cols count is too big to fit page width')
                return
            }

            console.log(`sticker width: ${config.sticker_width}\n
            sticker height: ${config.sticker_height}\n
            page width: ${pageWidth} page height: ${pageHeight}\n
            cols: ${config.col_count} rows: ${config.row_count}\n
            questions count: ${questionsCount}\n`)


            this.settings.onConfigSet(
                {
                    q_id_from: config.q_id_from,
                    q_id_to: config.q_id_to,
                    page_width: pageWidth,
                    page_height: pageHeight,
                    col_count: config.col_count,
                    rows_count: config.row_count,
                }
            )

        },
        getQuestionsCount() {
            let config = this.settings.pdfConfigDialogModel
            return config.q_id_to - config.q_id_from + 1
        },
        onOnePerPageClick() {
            this.settings.pdfConfigDialogModel.page_width = 0
            this.settings.pdfConfigDialogModel.page_height = 0
            this.settings.pdfConfigDialogModel.col_count = 1
            this.settings.pdfConfigDialogModel.row_count = 1
        },
        onRoedaClick() {
            this.settings.pdfConfigDialogModel.page_width = 104
            this.settings.pdfConfigDialogModel.page_height = 52
            this.settings.pdfConfigDialogModel.col_count = 1
            this.settings.pdfConfigDialogModel.row_count = 13
        },
        onSingleTestClick() {
            this.onOnePerPageClick()
            this.settings.pdfConfigDialogModel.q_id_from = 36358
            this.settings.pdfConfigDialogModel.q_id_to = 36358
            this.validate()
        },
    }

}
</script>

<style scoped>
.row_group {
    display: flex;
}

.row_group .form-group {
    margin-left: 4px;
    width: 50%;
}
.row_group.btns {
    gap: 8px;
}

.conf-btn {
    height: 38px;
    padding-left: 12px;
    padding-right: 12px;
    border: 1px solid black;
    border-radius: 4px;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: black;
}
.conf-btn:hover {
    background-color: #575757;
    color: white;
}

.red {
    color: red;
}

.hint {
    font-size: 11px;
}
.calc_btn {
    width: 65px;
    height: 35px;
    line-height: 35px;
    background-color: #dcdcdc;
    cursor: pointer;
}

</style>
